import { createAction } from "redux-actions";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT, LOGIN_FAILURE,CHANGE_PASS, RESET_STORE, RESPONSE_QUESTIONS} from "../constants";
import { ServerGetDataFeathers, serverLogout, serverLoginFailure, ServerLoginFeathers } from "./../services";
// import { userActions } from "./../api/Auth";
import { urlUsers } from "./../services/urls";



export const loginRequest = createAction(LOGIN_REQUEST, (user) => ServerLoginFeathers(user)())
export const loginSuccess = createAction(LOGIN_SUCCESS, () => ServerGetDataFeathers(urlUsers)())
export const logoutAction = createAction(LOGOUT, () => serverLogout()())
export const resetStore = createAction(RESET_STORE, () =>{})
export const loginFailure = createAction(LOGIN_FAILURE, () => serverLoginFailure()())
export const changeState = createAction(CHANGE_PASS, (state) => state)
export const responseQuestion = createAction(RESPONSE_QUESTIONS, (haveQuestions) => haveQuestions)





/* const loginUser = userObj => ({
    type: 'LOGIN_USER',
    payload: userObj
}) */